const formatDateIndian = (dateString = new Date()) => {
  let date = new Date(dateString);
  if (isNaN(date.getTime()) && typeof dateString === "string") {
    const parts = dateString.split(/[-/]/);
    if (parts.length === 3) {
      const [day, month, year] = parts;
      date = new Date(`${year}-${month}-${day}`);
    }
  }

  if (isNaN(date.getTime())) return "Invalid Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export default formatDateIndian;
